export function FormatNumber(value: number | null | undefined, decimalPlace: number)
{
    if (value == null || value == undefined) 
        return '';

    let formattedNumber = value.toFixed(decimalPlace).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    if (decimalPlace>0 && formattedNumber.indexOf('.')===-1)
    {
        var padZeros = "";
        for (let i = 0; i < decimalPlace; i++) {
            padZeros += "0";
        }
        formattedNumber += "." + padZeros;
    }
    let splitArray=formattedNumber.split('.');
    let integralPart = "";
    let decimalPart = "";
    if(splitArray.length>1)
    {
        integralPart = splitArray[0];
        decimalPart = splitArray[1];
        if (decimalPart.length<decimalPlace)
        {
            var rightPadZeros = "";
            for (let j = 0; j < decimalPlace - decimalPart.length; j++)
            {
                rightPadZeros += "0";
            }
            decimalPart += rightPadZeros; 
        }
        formattedNumber = integralPart + "." + decimalPart;
    } 
    return formattedNumber;
}

export function Pad(num: number, size: number) {
    var result = num.toString();
    while (result.length < size) result = "0" + result;
    return result;
}
